module.exports = __webpack_public_path__ + "img/describe5.ae92cb63.png";